import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { motion } from "framer-motion";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import Header from "../Header";

const HeroColumn = styled.section`
    ${tw`relative overflow-hidden bg-neutral-900 pt-header md:flex md:h-screen md:flex-col md:justify-end md:pt-0`}
`;

const IntroContents = [
    {
        id: 1,
        title: "AI 기반 자동화 \n" +
            "데이터 통합 플랫폼",
        detail: "분산된 대규모 데이터를 통합하고, 생성형 AI 및 에이전트 기반 오케스트레이션을 통해 자동화된 데이터 처리와 의사결정 지원을 실현하고 있습니다.",
    },
    {
        id: 2,
        title: "지속가능한 혁신을 위한 \n" +
            "R&D 리더십",
        detail: "기술의 연결을 넘어, 산업 전반의 지속가능한 혁신을 위한 R&D 역량을 기반으로, 미래 디지털 생태계의 변화를 주도해 나가고 있습니다.",
    },
];

function renderWithLineBreaks(text: string) {
    return text.split("\n").map((line, index) => (
        <React.Fragment key={index}>
            {line}
            <br/>
        </React.Fragment>
    ));
}

const Hero = () => {
    return (
        <>
            <Header />

            <HeroColumn>
                <img
                    className="lg:w-1/2 absolute bottom-0 md:-right-2 top-0 w-full object-cover object-center lg:block h-full
                   "
                    src="/img/img_sam-02.jpg"
                />

                <motion.div
                    initial={{ y: 150, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                    className="relative z-10 px-7 pb-5 md:absolute md:left-0 md:mb-24 lg:ml-4 lg:w-1/2"
                >
                    <p className="text-display font-semibold text-red-500">“</p>
                    <h1 className="">
                        <p className="text-gray-300 text-xl sm:text-2xl ">
                            ABOUT KUSRC
                        </p>
                        <p className="font-bold tracking-tight text-brand text-h1">
                            케이유융합소프트웨어
                            <br className="xl:hidden" />
                            연구센터
                        </p>
                    </h1>
                    <p className="mt-4 max-w-lg text-gray-300 text-base">
                        케이유융합소프트웨어연구센터는
                        데이터 통합(Data Integration), 지능형 AI 오케스트레이션,
                        비즈니스 인사이트를 위한 시각화 등 핵심 기술을 융합하여 차세대
                        디지털 전환(Digital Transformation)을 선도하는 연구소 기업입니다.
                    </p>
                    <ul className="mt-10 flex flex-col gap-3 sm:flex-row">
                        {IntroContents.map(list => (
                            <li
                                key={list.id}
                                className="flex w-full flex-col items-start justify-between gap-4 overflow-hidden
                                rounded-2xl bg-[#212427] p-6 sm:h-60 sm:w-1/2 sm:gap-0"
                            >
                                <p className="text-lead font-medium text-zinc-100 sm:text-xl">
                                    {renderWithLineBreaks(list.title)}
                                </p>
                                <p className="text-body text-zinc-100 lg:text-sm xl:text-base">
                                    {list.detail}
                                </p>
                            </li>
                        ))}
                    </ul>
                </motion.div>

                <motion.a
                    href="#tab"
                    onClick={e => {
                        e.preventDefault();
                        document
                            .getElementById("tab")
                            ?.scrollIntoView({ block: "start" });
                    }}
                    className="flex justify-center pb-4"
                >
                    <ChevronDownIcon className=" z-10 h-8 w-8 stroke-stone-200 stroke-2 md:h-12 md:w-12" />
                </motion.a>
            </HeroColumn>
        </>
    );
};

export default Hero;
